function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useState } from 'react';
import { SvgIconType } from 'common/components/svg-icon';
import { PropertySectionItem } from 'common/query-builder/query-block/properties-menu/item-menu-types';
import * as PropertiesMenu from 'common/query-builder/query-block/properties-menu/types';
import { getSegmentValuePropertyType, getSegmentValueResourceType, isCohortSegment, isExperimentSegment, isListOfObjectsSegment, isSegmentation, SegmentValue } from 'common/query-builder/query-block/segment-menu/types';
import { getSegmentTrackingProps } from 'common/query-builder/query-block/segment-menu/util';
import { Action, EntryPart, isObjectEntry, QuerySegmentEntry } from 'common/query-builder/query-entry-section/types';
import { getIconForPropertyType, isScdPropertyName } from 'common/report/util/properties';
import { QueryReason } from 'common/report/util/query-tracking/types';
import { Segmentation } from 'common/types/reports/query';
import { ActionType, trackLearningAction } from 'common/util/server-tracking';
// eslint-disable-next-line import/no-cycle
import { CustomBucketSubitem } from 'common/query-builder/query-entry-section/components/custom-bucket-subitem';
import { ProfileHistorySubItem } from 'common/query-builder/query-entry-section/components/profile-history-subitem';
import { TypecastSubitem } from 'common/query-builder/query-entry-section/components/typecast-subitem';
import { isAggregateUserFreqByGroupSegmentation, isMultiAttributionSegmentEntry, isRevenueBehaviorSegmentation, isTTCSegmentation } from 'common/query-builder/query-entry-section/row-types/behavior/utils';
import { FullPropertyType, PropertyType, ResourceType } from 'common/report/constants';
import { ControlBarAction, ControlBarActionItem, ControlBarActionItems, ControlBarActionValue, ControlSelectEntryPoint } from 'common/query-builder/query-entry-section/constants';
import { getEntryWithProfileHistory } from 'common/query-builder/query-entry-section/util/profile-history';
import { segmentationToPropertyItem } from 'common/query-builder/query-block/properties-menu/util';
import { unregisterTempLookupTableMapping } from 'common/report/stores/lookup-tables';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { SelectedPropertyItem } from 'common/query-builder/query-block/properties-menu/types';
import { getPropertySelectionFromProperty } from 'common/query-builder/query-entry-section/util/behavior';
import { useTranslation } from 'common/i18n/hooks';
import { BaseEntryRow } from '../base';
import { MultiAttributionBehaviorFilterSubItem } from '../behavior/multi-attribution-behavior-filter-subitem';
import { BehavioralSubFilters, BehavioralSubItem, MultiAttributionLookbackSubItem, PropertySelector, RevenueSubItem } from '../behavior/template';
import { getIconForBehavior, isEventBasedBehavioralSegmentation, isMultiAttributionSegmentation } from '../behavior/utils';
import { canMapPropToLookupTable, canUnmapPropFromLookupTable, getEntryPropertyType, getSegmentationProperty, isComputedListPropertyEntry, mapLookupTable, openCustomBucket, populateListPropertyAttrs, populateProfileHistoryOptions, setPropertyType } from '../row-util';
import { EntryRowProps } from '../types';
import { BehavioralStepSelectionSubItem } from '../behavior/behavioral-step-selection-subitem';
import { AggregateUserFrequencyByGroupSubItem } from '../behavior/aggregate-user-frequency-by-group-subitem';
import { getNextEntryPart } from '../filter/utils';
import { SegmentListObjectPropertySelector } from './components/segment-list-object-property-selector';
// eslint-disable-next-line import/no-cycle
import { helpers } from './helpers';
import { SegmentSCDOptionsSelector } from './components/segment-scd-options-selector/index';
function getSelectorIcon(entry: QuerySegmentEntry): SvgIconType {
  if (!entry.event) {
    return "search";
  }
  const segment = entry.event as Segmentation;
  if (entry.inheritedFromBoard) {
    return "brand-dashboard-gray";
  }
  if (isCohortSegment(segment)) {
    return "community";
  }
  if (isEventBasedBehavioralSegmentation(segment) || isMultiAttributionSegmentation(segment)) {
    return getIconForBehavior(segment.behavior);
  }
  if (isExperimentSegment(segment)) {
    return "experiment";
  }
  return getIconForPropertyType(getSegmentValuePropertyType(segment), {
    isCustom: segment && typeof segment === "object" && "customProperty" in segment,
    isScd: !!(segment !== null && segment !== void 0 && segment.scdEvent)
  });
}

/**
 * Generates tracking props for the selected segment
 */
function getTrackingProps(userId: number, selection: SegmentValue, rawItem?: PropertySectionItem) {
  let extraProps = {};
  if (isCohortSegment(selection) && rawItem) {
    extraProps = {
      'cohort type': rawItem.createdBy ? rawItem.createdBy.id === userId ? "cohorts-yours" : "cohorts" : "inline cohorts"
    };
  }
  return _objectSpread(_objectSpread({}, extraProps), getSegmentTrackingProps(selection));
}
export function SegmentEntryRow(props: EntryRowProps<QuerySegmentEntry>) {
  var _property$listItemGro, _multiAttributionBeha, _profileHistoryOption;
  const [entryEl, setEntryEl] = useState<HTMLDivElement>(null);
  const {
    t
  } = useTranslation();
  const isPlaceholder = helpers.isPlaceholder(props);
  const property = getSegmentationProperty(props.entry);
  const propertyType = (property === null || property === void 0 || (_property$listItemGro = property.listItemGroup) === null || _property$listItemGro === void 0 ? void 0 : _property$listItemGro.propertyType) || (property === null || property === void 0 ? void 0 : property.propertyType);
  const canCustomizeBuckets = props.sectionProps.canCustomizeNumericBuckets && (propertyType === PropertyType.Number || !isCohortSegment(props.entry.event) && propertyType !== PropertyType.Boolean);
  const multiAttributionBehavior = isMultiAttributionSegmentation(props.entry.event) ? props.entry.event.behavior : undefined;
  const shouldShowMultiAttributionBehavior = props.activePart === EntryPart.MultiAttributionBehaviorFilterValue || props.activePart === EntryPart.MultiAttributionBehaviorFilterOperator || (multiAttributionBehavior === null || multiAttributionBehavior === void 0 || (_multiAttributionBeha = multiAttributionBehavior.filters) === null || _multiAttributionBeha === void 0 ? void 0 : _multiAttributionBeha.length) > 0;
  const performTypecast = (toType: FullPropertyType) => {
    let segment = props.entry.event;
    if (!isCohortSegment(segment)) {
      if (Array.isArray(segment)) {
        segment = segment[0];
      }
      const newSegment = setPropertyType(segment, toType);
      props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
        event: newSegment
      }));
    } else {
      throw Error("typecast operation not possible");
    }
  };
  const onControlSelect = (value: ControlBarActionValue) => {
    switch (value.action) {
      case ControlBarAction.Typecast:
        performTypecast(value.toType);
        break;
      case ControlBarAction.CustomBreakdown:
        openCustomBucket(props, ControlSelectEntryPoint.ControlBar);
        break;
      case ControlBarAction.AddMultiAttributionBehaviorFilter:
        props.setActivePart(EntryPart.MultiAttributionBehaviorFilterValue, "open");
        break;
      case ControlBarAction.ProfileHistory:
        props.updateEntry(Action.Edit, getEntryWithProfileHistory(props.entry, value.toType), {
          trackingProps: {
            'Profile History Type': value.toType
          }
        });
        break;
      case ControlBarAction.MapLookupTable:
        mapLookupTable(props, property);
        break;
      case ControlBarAction.UnmapLookupTable:
        unregisterTempLookupTableMapping(segmentationToPropertyItem(property));
        props.removeEntry();
        props.dispatchTrack(QueryEntrySectionTrackingEvent.UnmappedTable, props.getEntryTrackingProps());
        addToast({
          message: "Removed temporary lookup table mapping",
          type: ToastType.DESTRUCTIVE
        });
        break;
      default:
        props.onControlSelect(value);
    }
  };
  const handleListObjectPropertySelect = (selection: Segmentation) => {
    const segment = props.entry.event as Segmentation;
    if (selection.unit) {
      // for date properties, "unit" should be outside of listItemGroup (just like the other custom segment
      // properties `customGroups` and `customBucket`)
      segment.unit = selection.unit;
    }
    segment.listItemGroup = _objectSpread({
      resourceType: selection.resourceType,
      propertyName: selection.propertyName,
      propertyDefaultType: selection.propertyDefaultType,
      propertyType: selection.propertyType
    }, selection.propertyObjectKey ? {
      propertyObjectKey: selection.propertyObjectKey
    } : {});
    triggerUpdate(segment, QueryReason.QbBreakdownUpdate);
  };
  const triggerUpdate = function triggerUpdate(value: SegmentValue, queryReason: QueryReason) {
    var _queryReason, _behavior;
    let rawItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    queryReason = (_queryReason = queryReason) !== null && _queryReason !== void 0 ? _queryReason : QueryReason.QbBreakdownUpdate;
    const source = getSegmentValueResourceType(value);
    const trackingProps = getTrackingProps(props.sectionProps.userId, value, rawItem);
    if (queryReason === QueryReason.QbBreakdownUpdate && props.sectionProps.propertyCombineMode !== PropertiesMenu.PropertyCombineMode.Intersection) {
      // for cases where the segmentation menu is used outside of breakdowns, disable
      // learning action tracking
      trackLearningAction({
        projectId: props.sectionProps.projectId,
        reportName: props.sectionProps.trackName,
        actionType: ActionType.Breakdown,
        resourceType: source
      });
    }

    // when de-selecting all selected items, remove the current entry
    if (Array.isArray(value) && value.length === 0) {
      props.removeEntry(QueryReason.QbOtherUpdate);
      return;
    }

    // If we change the property for multi attribution, we need to clear the filters
    if (isSegmentation(value) && isSegmentation(props.entry.event) && isMultiAttributionSegmentation(value) && value.propertyName !== props.entry.event.propertyName) {
      value.behavior.filters = [];
    }
    const updatedEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      event: value
    });
    const isStagingChanges = props.isStagingEntryChanges(props.entry, updatedEntry);
    if (isStagingChanges || !((_behavior = (value as Segmentation).behavior) !== null && _behavior !== void 0 && _behavior.property) || (value as Segmentation).behavior) {
      // when changing a committed filter to an invalid filter, or when the filter property
      // is selected for the first time, set focus to the filter value selection
      props.setActivePart(getNextEntryPart(value as Segmentation), "open");
    }
    props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      event: value
    }), {
      trackingProps,
      queryReason
    });
  };
  const handlePropertySelect = (selection: SegmentValue, queryReason?: QueryReason) => {
    var _selection$behavior$e;
    if (isTTCSegmentation(selection)) {
      props.setActivePart(EntryPart.SubValue, "open");
    }
    if (isSegmentation(selection)) {
      var _selection$behavior$p, _selection$behavior$f;
      populateListPropertyAttrs(selection);
      if (isListOfObjectsSegment(selection) || isRevenueBehaviorSegmentation(selection) && !((_selection$behavior$p = selection.behavior.property) !== null && _selection$behavior$p !== void 0 && _selection$behavior$p.value) || isAggregateUserFreqByGroupSegmentation(selection) && selection.behavior.filters.length && !((_selection$behavior$f = selection.behavior.filters[0].behavior) !== null && _selection$behavior$f !== void 0 && (_selection$behavior$f = _selection$behavior$f.property) !== null && _selection$behavior$f !== void 0 && _selection$behavior$f.value)) {
        // props.setActivePart(EntryPart.SubValue, `open`);
      }
      if (props.isProfileHistoryEnabled) {
        selection = populateProfileHistoryOptions(selection, props.sectionProps.hideEvents);
      }
    }
    if (isEventBasedBehavioralSegmentation(selection) && !((_selection$behavior$e = selection.behavior.event) !== null && _selection$behavior$e !== void 0 && _selection$behavior$e.value)) {
      props.setActivePart(selection.behavior.aggregationOperator ? EntryPart.SubValue : EntryPart.Aggregator, "open");
    }
    triggerUpdate(selection, queryReason);
  };
  const selectorRenderer = () => <PropertySelector {...props} contextPanelParentElement={entryEl} onSelect={(propertyItem: SelectedPropertyItem, queryReason) => {
    const segment = props.entry.event as Segmentation;
    const handledEvent = getPropertySelectionFromProperty(propertyItem, segment, {
      chartType: props.sectionProps.chartType,
      dateUnit: props.sectionProps.dateUnit,
      isForFilter: false,
      reportName: props.sectionProps.reportName,
      dataGroupId: props.sectionProps.dataGroupId
    }) as SegmentValue;
    handlePropertySelect(handledEvent, queryReason);
  }} isPlaceholder={isPlaceholder} selected={props.entry.event} data-sentry-element="PropertySelector" data-sentry-component="selectorRenderer" data-sentry-source-file="index.tsx" />;
  const bodyRowRenderer = () => {
    var _props$entry$event;
    const segment = props.entry.event as Segmentation;
    return <>
        {!props.sectionProps.disableScdOptions && isScdPropertyName(segment === null || segment === void 0 ? void 0 : segment.propertyName) && <SegmentSCDOptionsSelector hasNewUI={props.hasNewUI} segment={segment} onSelect={handlePropertySelect} />}
        {isListOfObjectsSegment(segment) && <SegmentListObjectPropertySelector {...props} segment={segment} handleSelect={handleListObjectPropertySelect} />}
        {/* renders behavioral controls (time & aggregation) for the selected property */}
        {isEventBasedBehavioralSegmentation(segment) && ((_props$entry$event = props.entry.event) === null || _props$entry$event === void 0 ? void 0 : _props$entry$event["behavior"]) && <BehavioralSubItem {...props} contextPanelParentElement={entryEl} selected={segment} onSelect={handlePropertySelect} isPlaceholder={isPlaceholder} />}
        {isRevenueBehaviorSegmentation(segment) && <RevenueSubItem {...props} contextPanelParentElement={entryEl} selected={segment} onSelect={handlePropertySelect} isPlaceholder={isPlaceholder} />}
        {isAggregateUserFreqByGroupSegmentation(segment) && <>
            <AggregateUserFrequencyByGroupSubItem {...props} contextPanelParentElement={entryEl} selected={segment} onSelect={handlePropertySelect} isPlaceholder={isPlaceholder} isFilter={false} />
          </>}
        {isTTCSegmentation(segment) && props.entry.event && <BehavioralStepSelectionSubItem stepCount={props.sectionProps.stepCount} selected={segment} onChange={handlePropertySelect} />}
        <MultiAttributionLookbackSubItem {...props} selected={segment} onSelect={handlePropertySelect} data-sentry-element="MultiAttributionLookbackSubItem" data-sentry-source-file="index.tsx" />
        {shouldShowMultiAttributionBehavior && <MultiAttributionBehaviorFilterSubItem selected={segment} behavior={multiAttributionBehavior} onChange={handlePropertySelect} projectId={props.sectionProps.projectId} workspaceId={props.sectionProps.workspaceId} operatorOpen={props.activePart === EntryPart.MultiAttributionBehaviorFilterOperator} valueOpen={props.activePart === EntryPart.MultiAttributionBehaviorFilterValue} onOperatorOpen={() => props.setActivePart(EntryPart.MultiAttributionBehaviorFilterOperator, "open")} onValueOpen={() => props.setActivePart(EntryPart.MultiAttributionBehaviorFilterValue, "open")} />}
        <CustomBucketSubitem {...props} data-sentry-element="CustomBucketSubitem" data-sentry-source-file="index.tsx" />
        <TypecastSubitem value={props.entry.event} onTypeChange={seg => handlePropertySelect(seg, QueryReason.QbBreakdownUpdate)} data-sentry-element="TypecastSubitem" data-sentry-source-file="index.tsx" />
        {props.isProfileHistoryEnabled && (segment === null || segment === void 0 ? void 0 : segment.resourceType) === ResourceType.User && <ProfileHistorySubItem hasNewUI={props.hasNewUI} value={segment} onTypeChange={(seg: Segmentation) => {
        handlePropertySelect(seg, QueryReason.QbBreakdownUpdate);
      }} hideEvents={props.sectionProps.hideEvents} selectorType={props.entry.type} />}
      </>;
  };
  const suffixRenderer = () => <>
      {/* renders filters applied to a behavior's event */}
      <BehavioralSubFilters {...props} onSelect={handlePropertySelect} selected={props.entry.event} data-sentry-element="BehavioralSubFilters" data-sentry-source-file="index.tsx" />
    </>;
  const overflowControls: ControlBarActionItem[] = [...props.getCommonOverflowControls(),
  // customize buckets
  canCustomizeBuckets && props.entry.event && ControlBarActionItems[ControlBarAction.CustomBreakdown](getEntryPropertyType(props.entry)),
  // filter attribution touchpoints by property value
  multiAttributionBehavior && ControlBarActionItems[ControlBarAction.AddMultiAttributionBehaviorFilter],
  // profile history
  props.isProfileHistoryEnabled && (property === null || property === void 0 ? void 0 : property.resourceType) === ResourceType.User && ControlBarActionItems[ControlBarAction.ProfileHistory]({
    currentProfileHistoryType: (_profileHistoryOption = (props.entry.event as Segmentation).profileHistoryOptions) === null || _profileHistoryOption === void 0 ? void 0 : _profileHistoryOption.type,
    hideEvents: props.sectionProps.hideEvents,
    selectorType: props.entry.type
  }),
  // typecasting
  property && !isComputedListPropertyEntry(props.entry) && !props.sectionProps.disableTypecast && !isMultiAttributionSegmentEntry(props.entry) && ControlBarActionItems[ControlBarAction.Typecast](getEntryPropertyType(props.entry), {
    disabledTypes: props.sectionProps.disabledTypecastTypes
  }),
  // map to lookup table
  !isPlaceholder && !props.sectionProps.disableMapToLookupTable && !isObjectEntry(props.entry) && property && canMapPropToLookupTable(segmentationToPropertyItem(property)) && ControlBarActionItems[ControlBarAction.MapLookupTable],
  // unmap from lookup table
  !isPlaceholder && property && canUnmapPropFromLookupTable(segmentationToPropertyItem(property)) && ControlBarActionItems[ControlBarAction.UnmapLookupTable]];
  return <BaseEntryRow ref={setEntryEl} {...props} showDefaultMetricUnitSelector={false} renderBody={bodyRowRenderer} renderSelector={selectorRenderer} renderSuffix={suffixRenderer} isPlaceholder={isPlaceholder} entryIcon={getSelectorIcon(props.entry)} onControlSelect={onControlSelect} canDelete={!props.entry.inheritedFromBoard && props.canDelete} disabled={props.entry.inheritedFromBoard} tooltip={props.entry.inheritedFromBoard ? t("query-builder.breakdown-inherited-from-board") : ""} overflowControls={props.entry.inheritedFromBoard ? [] : overflowControls} data-sentry-element="BaseEntryRow" data-sentry-component="SegmentEntryRow" data-sentry-source-file="index.tsx" />;
}